
/* Customer MODEL */
import { language } from "@Language";
import { get } from "lodash"
import { makeAutoObservable } from "mobx";
import StoreAuth from "./StoreAuth";
import $ from 'jquery'

const inArray = (needle, arrayList) => {
    return $.inArray(needle, arrayList) > -1 ? true : false
}
class Customer {

    userData = null

    constructor(userData) {
        makeAutoObservable(this)
        this.userData = userData
    }

    GetNativeName(obj, nameType) {
        var fullName = '';
        var nativeName = '';

        let checkNative = /@/
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];

            if (checkNative.test(key)) {
                nativeName = value
            } else {

                nativeName = false
                if (key === 'firstName' || key === 'lastName') {
                    fullName += value
                } else if (key === 'fullName') {
                    fullName = value
                }
            }

        });


        if (nameType === 'fullName') {
            return fullName;
        } else if (nameType === 'nativeName') {
            if (nativeName === false || nativeName === '') {
                return fullName;
            } else {
                return nativeName;
            }
        } else {

            if (nativeName === '') {
                return fullName;
            } else {
                if (nativeName === false || nativeName === '') {
                    return fullName
                } else {
                    return nativeName
                }
            }

        }

    }

    Rank() {

        const rank = get(this.userData, 'metricsProfileHistory.aggregate.cumulativeMetricsProfile.highestRankShort', '').toLowerCase() 

        return rank === 'pc' ? 'dst' : rank
    }

    IsVip() {

    }

    get ProfilePicture() {
        return get(this.userData, 'profilePicture', null)
    }

    get CustomerId() {
        return get(this.userData, 'id.unicity', null)
    }

    Email() {
        return get(this.userData, 'email', null)
    }

    FullName() {
        return this.userData ? this.GetNativeName(this.userData.humanName, 'fullName') : null
    }

    NativeName() {
        return this.userData ? this.GetNativeName(this.userData.humanName, 'nativeName') : null
    }

    Name() {
        return language.current === 'EN' ? this.FullName() : this.NativeName()
    }

    MainAddress() {
        return get(this.userData, 'mainAddress', null)
    }

    MobilePhone() {
        return get(this.userData, 'mobilePhone', null)
    }


    AchievementsHistory() {
        return get(this.userData, 'achievementsHistory', null)
    }

    Sponsor() {
        return get(this.userData, 'sponsor', null)
    }

    Enroller() {
        return get(this.userData, 'enroller', null)
    }

    EnrollerId() {

        const enroller = this.Enroller()

        return enroller ? enroller.id.unicity : null
    }

    MetricProfile() {
        
    }

    IsCPWE() {
        const fullAccess = ['Associate', 'Pending']
        //['Customer', 'WholesaleCustomer', 'PreferredCustomer', 'Employee']
        if (inArray(this.Type(), fullAccess)) {
            return false
        } else {
            return true
        }
    }

    Type() {
        let t = get(this.userData, 'type', null)
        if (t) {
            if (t === 'Employee') {
                if (get(this.userData, 'employmentDetails.employerName', null)) {
                    t = get(this.userData, 'employmentDetails.employerName', null)
                }
            }
        }

        return t
    }

    Status() {
        return get(this.userData, 'status', null)
    }

    Country() {
        return get(this.userData, 'mainAddress.country', null)
    }

    get status() {
        return this.Status()
    } 

    JoinDate() {
        let joinDate = get(this.userData, 'joinDate', null)

        if(joinDate) {
            return joinDate.split('T')[0]
        } else {
            return null
        }
    }
}

export default Customer